import { lazy } from "react";
import type { RouteObject } from "react-router";

export const recoverRoute: RouteObject = {
  path: "recover",
  children: [
    {
      path: "user/:username/:token",

      // AuthWrapper checks this for if it requires login:
      // note that it only checks the leaf route.
      handle: {
        public: true,
        // invites has: `disableHeaderNavigation: true,` but without
        // a user menu that means we can't go anywhere.
      },
      Component: lazy(() => import("./RecoverUserPage.tsx")),
    },
  ],
};
